import React from 'react';
import { Popup } from 'react-map-gl';
import guid from "../../../../utils/Guid";

export interface IPopupProps {
  coordinates: number[];
  onClose?: () => void;
}

export const PointPopup: React.FC<{ popup: IPopupProps, children?: React.ReactNode | string; }> = (props) => {
  const handleClose = () => {
    props?.popup?.onClose?.();
  }
  return (
    <Popup
      key={guid()}
      offset={30}
      anchor="bottom"
      longitude={props!.popup.coordinates[0]}
      latitude={props!.popup.coordinates[1]}
      closeOnClick={false}
      closeButton={true}
      onClose={handleClose}
      style={{
        minWidth: 250
      }}
    >
      {props!.children}
    </Popup>
  );
};
